<template>
  <div v-if="auctionDocuments.length">
    <div class="subtitle-form label-heading flex-row">
      <div class="inline">
        <h3 style="margin: 0">Auction Documents</h3>
      </div>
    </div>
    <v-data-table
      :headers="tableHeaders"
      :items="auctionDocuments"
      hide-default-footer
      class="data-table subscribers-form bidders elevation-1"
    >
      <template v-slot:item.documentType="{ item }">
        {{ documentTypeLabel(item.documentType) }}
      </template>
      <template v-slot:item.url="{ item }">
        <a target="_blank" :title="linkText(item)" :href="item.url">{{
          cutString(linkText(item), 30)
        }}</a>
        &nbsp;
        <v-tooltip bottom>
          <template #activator="{ on }">
            <img
              @click="copyToClipboard(item.url)"
              src="../../assets/copy.png"
              class="copy"
              alt="Copy"
              v-on="on"
            />
          </template>
          <div>COPY</div>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { documentTypeLabel, isAuctionLevelDocument } from '@/constants/auction';
import { copyWithSnackbar } from '@/utils/clipboard';

export default {
  props: {
    auction: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tableHeaders: [
        { text: 'Type', align: 'left', sortable: false, value: 'documentType' },
        { text: 'Document', align: 'left', sortable: false, value: 'url' },
      ],
    };
  },
  computed: {
    auctionDocuments() {
      return (this.auction.documents || []).filter(isAuctionLevelDocument);
    },
  },
  methods: {
    ...mapActions(['showSnackbar']),
    documentTypeLabel,
    // The url is served by the portal and carries what authorises it, so it is
    // rendered exactly as it arrived -- nothing is appended or rebuilt here.
    linkText(document) {
      return document.title || document.url;
    },
    cutString(text, size) {
      if (text.length > size) {
        return text.slice(0, size) + '...';
      } else {
        return text;
      }
    },
    copyToClipboard(text) {
      return copyWithSnackbar({
        copyText: this.$copyText,
        showSnackbar: this.showSnackbar,
        text,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  text-align: left;
  color: #2e7f89;
  margin-top: 36px;
}
.flex-row {
  margin-top: 40px !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: space-between !important;
}
.label-heading {
  display: block;
  border-left: 5px solid #2e7f89;
  box-sizing: border-box;
  margin-left: -18px;
  padding-left: 14px;
}
.subtitle-form {
  padding: 0 7px 0 17px;
  width: 55%;
  min-width: 900px;
  margin: 0 auto 14px auto;
  justify-content: space-between;
  flex-direction: row;
}
.subscribers-form {
  padding: 0;
  display: flex;
  width: 55%;
  min-width: 900px;
  margin: 0 auto 9px auto;
  justify-content: space-between;
  flex-direction: column;
  background: #ffffff;
}
.data-table td {
  text-align: left !important;
}
.inline {
  display: inline-block;
}
.copy {
  cursor: pointer;
}
@media (max-width: 1000px) {
  img {
    margin-left: 34px;
  }
  .subtitle-form,
  .subscribers-form {
    min-width: 90% !important;
  }
}
</style>
